import { render, staticRenderFns } from "./NewMenu.vue?vue&type=template&id=653d05b8&scoped=true&"
import script from "./NewMenu.vue?vue&type=script&lang=js&"
export * from "./NewMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewMenu.vue?vue&type=style&index=0&id=653d05b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d05b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VFlex,VIcon})
